import { SynchronizedTime } from '@exodus/basic-utils';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

// Register dayjs plugins.
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);

export function formatDate(date, { short = false, noYear = false } = {}) {
  return dayjs(date).format(
    `${short ? 'MMM' : 'MMMM'} D${noYear ? '' : ', YYYY'}`,
  );
}

export function formatTime(date) {
  return dayjs(date).format('h:mm A');
}

export function formatDatetime(date) {
  return dayjs(date).format('D MMM YYYY h:mm A');
}

export function isValidDate(
  day?: number,
  month?: number,
  year?: number,
): boolean {
  if (day === undefined || month === undefined || year === undefined) {
    return false;
  }

  const date = new Date(year, month - 1, day);

  // Date is invalid if it rolled over any parts.
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

// This looks stupid because we have `startOfDayLocal`.
// However, the performance difference is substantial for a long `txSet`.
// For ~800 transactions, this changes runtime from 800ms to 40ms.
export function startOfDayTimestampLocal(date: Date) {
  return (
    Math.floor(
      (date.getTime() - date.getTimezoneOffset() * 60_000) / 86_400_000,
    ) *
      86_400_000 +
    date.getTimezoneOffset() * 60_000
  );
}

// TODO: Can we reuse `endOfTimestamp`?
export function endOf24HoursAgoTimestamp() {
  return dayjs(SynchronizedTime.now())
    .endOf('hour')
    .subtract(24, 'hour')
    .valueOf();
}
